! function(e) {
  var t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var o = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports
  }
  n.m = e, n.c = t, n.d = function(e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    })
  }, n.r = function(e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    })
  }, n.t = function(e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e)
      for (var o in e) n.d(r, o, function(t) {
        return e[t]
      }.bind(null, o));
    return r
  }, n.n = function(e) {
    var t = e && e.__esModule ? function() {
      return e.default
    } : function() {
      return e
    };
    return n.d(t, "a", t), t
  }, n.o = function(e, t) {
    return Object.prototype.hasOwnProperty.call(e, t)
  }, n.p = "/js/", n(n.s = 0)
}([function(e, t, n) {
  n(1), n(2), n(3)
}, function(e, t) {
  ! function() {
    const e = document.querySelector("html");
    !!e && e.classList.replace("no-js", "js")
  }()
}, function(e, t) {
  ! function() {
    function e(e) {
      return e && sessionStorage[e] ? sessionStorage[e] : JSON.stringify(sessionStorage)
    }

    function t(e) {
      if (!e) return !1;
      var t = function(e) {
        try {
          return e instanceof HTMLElement
        } catch (t) {
          return "object" == typeof e && 1 === e.nodeType && "object" == typeof e.style && "object" == typeof e.ownerDocument
        }
      }(e) ? e : document.querySelector(e);
      return t.parentElement.removeChild(t), t
    }
    var n;
    (n = window.Node || window.Element) && n.prototype && null == n.prototype.children && Object.defineProperty(n.prototype, "children", {
      get: function() {
        let e, t = 0,
          n = this.childNodes,
          r = [];
        for (; e = n[t++];) 1 === e.nodeType && r.push(e);
        return r
      }
    });
    /*!
     * Serialize all form data into an object of key/value pairs
     * (c) 2020 Chris Ferdinandi, MIT License, https://gomakethings.com
     * @param  {Node}   form The form to serialize
     * @return {Object}      The serialized form data
     */
    var r = function(e) {
      var t = {};
      return Array.prototype.slice.call(e.elements).forEach((function(e) {
        if (!(!e.name || e.disabled || ["file", "reset", "submit", "button"].indexOf(e.type) > -1)) {
          if ("select-multiple" === e.type) {
            var n = [];
            return Array.prototype.slice.call(e.options).forEach((function(e) {
              e.selected && n.push(e.value)
            })), void(n.length && (t[e.name] = n))
          } ["checkbox", "radio"].indexOf(e.type) > -1 && !e.checked || (t[e.name] = e.value)
        }
      })), t
    };

    function o() {
      const n = e("fhp"),
        r = JSON.parse(n),
        o = function(e) {
          if (!e) return !1;
          var t = new RegExp("[\\?&]" + e.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]") + "=([^&#]*)").exec(location.search);
          return !!t && decodeURIComponent(t[1].replace(/\+/g, " "))
        }("brand");
      if (o && "" !== o && (r.brand = o, r.courseCompleted = !0), !r.courseCompleted) return !1;
      const i = document.querySelector("#courseCompleted");
      return i && (i.value = r.courseCompleted), !!r.brand && (!!r.pledge && (function(e, n) {
        const r = document.querySelector("body");
        Array.prototype.slice.call(r.children).forEach(e => {
          t(e)
        }), r.classList.add("certificate");
        const o = {
            BHGRE: {
              logo: "/img/logos/logo-bhgre.svg",
              executive: {
                name: "Sherry A. Chris",
                title: "President and Chief Executive Officer",
                company: "Anywhere Expansion Brands",
                signature: "/img/signatures/sherry-chris.jpg"
              },
              icon: "/img/icons/fhp-icon-bhgre.svg",
              class: "bhgre",
              disclaimer: "© 2022 Better Homes and Gardens Real Estate LLC. All rights reserved. Better Homes and Gardens® and the Better Homes and Gardens Real Estate Logo are registered service marks owned by Meredith Corporation and licensed to Better Homes and Gardens Real Estate LLC.Better Homes and Gardens Real Estate LLC fully supports the principles of the Fair Housing Act and the Equal Opportunity Act. Each office is independently owned and operated."
            },
            C21: {
              logo: "/img/logos/logo-c21.svg",
              executive: {
                name: "Michael Miedler",
                title: "President and Chief Executive Officer",
                company: "Century 21 Real Estate LLC",
                signature: "/img/signatures/michael-miedler.jpg"
              },
              icon: "/img/icons/fhp-icon-c21.svg",
              class: "c21",
              disclaimer: "© 2022 Century 21 Real Estate LLC. All rights reserved. CENTURY 21 and the CENTURY 21 Logo are service marks owned by Century 21 Real Estate LLC. Century 21 Real Estate LLC fully supports the principles of the Fair Housing Act and the Equal Opportunity Act. Eachoffice is independently owned and operated."
            },
            "Coldwell Banker": {
              logo: "/img/logos/logo-cb.svg",
              executive: {
                name: "Ryan Gorman",
                title: "President and Chief Executive Office",
                company: "Coldwell Banker",
                signature: "/img/signatures/ryan-gorman.jpg"
              },
              icon: "/img/icons/fhp-icon-cb.svg",
              class: "cb",
              disclaimer: "©2022 Coldwell Banker. All Rights Reserved. Coldwell Banker and the Coldwell Banker logos are trademarks of Coldwell Banker Real Estate LLC. The Coldwell Banker® System is comprised of company owned offices which are owned by a subsidiary of Anywhere Advisors LLC and franchised offices which are independently owned and operated. The Coldwell Banker System fully supports the principles of the Fair Housing Act and the Equal Opportunity Act."
            },
            Corcoran: {
              logo: "/img/logos/logo-corcoran.svg",
              executive: {
                name: "Pamela Liebman",
                title: "President and Chief Executive Officer",
                company: "Corcoran",
                signature: "/img/signatures/pamela-liebman.jpg"
              },
              icon: "/img/icons/fhp-icon-corcoran.svg",
              class: "corcoran",
              disclaimer: "©2022 Corcoran. All Rights Reserved. Corcoran and the Corcoran logo are trademarks of Corcoran Group LLC. The Corcoran® System is comprised of company-owned offices which are owned by a subsidiary of Anywhere Advisors LLC and franchised offices which are independently owned and operated. The Corcoran System fully supports the principles of the Fair Housing Act and the Equal Opportunity Act."
            },
            ERA: {
              logo: "/img/logos/logo-era.svg",
              executive: {
                name: "Sherry A. Chris",
                title: "President and Chief Executive Officer",
                company: "Anywhere Expansion Brands",
                signature: "/img/signatures/sherry-chris.jpg"
              },
              icon: "/img/icons/fhp-icon-era.svg",
              class: "era",
              disclaimer: "© 2022 ERA Franchise System LLC. All Rights Reserved. ERA® and the ERA Logo are registered service marks owned by ERA Franchise Systems LLC. ERA Franchise Systems LLC fully supports the principles of the Fair Housing Act and the Equal Opportunity Act. Each office is independently owned and operated."
            },
            Anywhere: {
              logo: "/img/logos/logo-realogy.svg",
              executive: {
                name: "Sue Yannaccone",
                title: "President & CEO",
                company: "Anywhere Brands",
                signature: "/img/signatures/sue-yannaccone.png"
              },
              icon: "/img/icons/fhp-icon-realogy.svg",
              class: "anywhere",
              disclaimer: "©2022 Anywhere Real Estate Inc. All Rights Reserved. Anywhere Real Estate Inc. fully supports the principles of the Fair Housing Act and the Equal Opportunity Act."
            },
            SIR: {
              logo: "/img/logos/logo-sir.svg",
              executive: {
                name: "Philip A. White, Jr.",
                title: "President and Chief Executive Officer",
                company: "Sotheby’s International Realty",
                signature: "/img/signatures/philip-white.jpg"
              },
              icon: "/img/icons/fhp-icon-sir.svg",
              class: "sir",
              disclaimer: "©2022 Sotheby's International Realty. All Rights Reserved. Sotheby's International Realty and the Sotheby's International Realty logo are trademarks licensed to Sotheby’s International Realty Affiliates LLC and used with permission. The Sotheby's International Realty® affiliate network is operated by Sotheby's International Realty Affiliates LLC, and the company owned brokerages are operated by Sotheby's International Realty, Inc. Both entities are subsidiaries of Anywhere Real Estate Inc. Both Sotheby's International Realty Affiliates LLC and Sotheby's International Realty, Inc. fully support the principles of the Fair Housing Act and the Equal Opportunity Act."
            }
          },
          i = o.hasOwnProperty(e) ? e : "Anywhere";
        r.classList.add("certificate_" + o[i].class);
        const a = new Date;
        r.innerHTML = `<header class="certificate__header container pad">\n    <img class="certificate__icon" src="/img/icons/house-and-hands.jpg" alt="House and hands">\n  </header>\n  <main class="certificate__main container pad">\n    <h1 class="certificate__title">Certificate of Completion</h1>\n    <p>is hereby granted to</p>\n    <h2 class="certificate__name">${n.firstName} ${n.lastName}</h2>\n    <p>to certify that they have completed to<br />\n    satisfaction the Fair Housing Course.</p>\n    <p>Granted ${["January","February","March","April","May","June","July","August","September","October","November","December"][a.getMonth()]} ${a.getDate()}, ${a.getFullYear()}</p>\n    <img class="certificate__signature" src="${o[i].executive.signature}" alt="${o[i].executive.name}">\n    <p>${o[i].executive.name}<br />\n    ${o[i].executive.title}<br />\n    ${o[i].executive.company}</p>\n    <img class="certificate__logo" src="${o[i].logo}" alt="${i}">\n  </main>\n  <footer class="certificate__footer pad">\n    <p class="certificate__disclaimer">${o[i].disclaimer}</p>\n  </footer>`
      }(r.brand, JSON.parse(r.pledge)), !0))
    }

    function i(e) {
      const t = document.querySelector('[data-acc-text="100%"]');
      if (!t) return !1;
      const n = "block" === window.getComputedStyle(t).getPropertyValue("display"),
        r = "Rectangular Hotspot 1" === e.target.parentElement.parentElement.parentElement.parentElement.getAttribute("data-acc-text");
      if (!n || !r) return !1;
      e.preventDefault();
      let o = document.querySelector("title").textContent.replace("The Promise to Deliver Fair Housing", "").trim();
      if ("" === o && (o = "Coldwell Banker"), window.gtag) {
        const e = {
          event_category: o + " Course",
          event_label: "Finish"
        };
        window.gtag("event", "course_view", e)
      }
      return sessionStorage.setItem("fhp", JSON.stringify({
        brand: o,
        courseCompleted: !0
      })), e.target.click(), !0
    }

    function a(t) {
      t.preventDefault();
      const n = document.querySelector('[name="pledge"] [type="submit"]');
      var o;
      n.setAttribute("disabled", ""), n.textContent = "Submitting...", window.gtag && window.gtag("event", "sign_up", {
        method: (o = t.target.name, !!o && o.charAt(0).toUpperCase() + o.slice(1))
      });
      const i = e("fhp"),
        a = JSON.parse(i),
        s = JSON.stringify(r(t.target));
      return a.pledge = s,
        function(t, n) {
          if (!t) return !1;
          const r = "string" == typeof n || n instanceof String ? n : JSON.stringify(n);
          sessionStorage.setItem(t, r), e(t)
        }("fhp", a),
        function(e) {
          if (!e.target.matches("#pledge")) return !1;
          e.preventDefault(), fetch("https://fairhousingpledge.com/api/pledges", {
            method: "POST",
            body: JSON.stringify(r(e.target)),
            mode: "cors"
          }).then((function(e) {
            return e.ok ? e.json() : Promise.reject(e)
          })).then((function(e) {
            console.log("Pledge submission successfull.")
          })).catch((function(e) {
            console.warn("Pledge submission error.", e)
          })).finally((function() {
            e.target.submit()
          }))
        }(t), t.target.submit(), !0
    }
    window.addEventListener("load", o), window.addEventListener("click", i), window.addEventListener("submit", a)
  }()
}, function(e, t) {
  ! function() {
    console.log("init is running");
    if (!document.querySelector(".page-sendCertificate")) return !1;
    const e = JSON.parse(sessionStorage.getItem("fhp"));
    console.log(e);
    const t = JSON.parse(e.pledge),
      n = t.company,
      r = document.querySelector("#brokerage1"),
      o = document.querySelector("#brokerage2");
    r.textContent = n, o.textContent = n;
    const i = t.brand;
    console.log("Brand is: " + i);
    var a = document.getElementById("brandHeaderID"),
      s = document.getElementById("brandFooterID");
    switch (i) {
      case "Better Homes and Gardens Real Estate":
        console.log("brand: " + i), a.src = "/img/certificate/FH Pledge_BHG_H.jpg", s.src = "/img/certificate/FH Pledge_BHG_F.jpg";
        break;
      case "Century 21 Real Estate":
        console.log("brand: " + i), a.src = "/img/certificate/C21-Header.jpg", s.src = "/img/certificate/C21-Footer.jpg";
        break;
      case "Coldwell Banker - Company Owned (previously NRT)":
      case "Coldwell Banker - Affiliates":
        console.log("brand: " + i), a.src = "/img/certificate/FH Pledge_CB_H.jpg", s.src = "/img/certificate/FH Pledge_CB_F.jpg";
        break;
      case "Coldwell Banker Commercial":
        console.log("brand: " + i), a.src = "/img/certificate/FH Pledge_CBC_H.jpg", s.src = "/img/certificate/FH Pledge_CBC_F.jpg";
        break;
      case "Corcoran":
        console.log("brand: " + i), a.src = "https://i.ibb.co/XzRG9ym/FH-Pledge-Corcoran-H.jpg", s.src = "https://i.ibb.co/NxTRSN5/FH-Pledge-Corcoran-F.jpg";
        break;
      case "ERA Real Estate":
        console.log("brand: " + i), a.src = "https://i.ibb.co/Jy4CP10/FH-Pledge-ERA-H.jpg", s.src = "https://i.ibb.co/b1kdzZX/FH-Pledge-ERA-F.jpg";
        break;
      case "Sotheby's International Realty":
        console.log("brand: " + i), a.src = "/img/certificate/FH Pledge_SIR_H.jpg", s.src = "/img/certificate/FH Pledge_SIR_F.jpg";
        break;
      case "AREAA":
        console.log("brand: " + i), a.src = "https://i.ibb.co/3WffJWc/AREAA-Header.jpg", s.src = "https://i.ibb.co/w7W4N04/AREAA-Footer.jpg";
        break;
      case "LGBTQ+ Real Estate Alliance":
        console.log("brand: " + i), a.src = "https://i.ibb.co/0QdMzvK/Alliance-Header.jpg", s.src = "https://i.ibb.co/n8cWPwW/Alliance-Footer.jpg";
        break;
      case "NAHREP":
        console.log("brand: " + i), a.src = "https://i.ibb.co/MDZ85n0/NAHREP-Header.jpg", s.src = "https://i.ibb.co/nRFNcch/NAHREP-Footer.jpg";
        break;
      case "NAREB":
        console.log("brand: " + i), a.src = "https://i.ibb.co/ryK3sCL/NAREB-Header.gif", s.src = "https://i.ibb.co/gWMLsVK/NAREB-Footer.jpg";
        break;
      case "NAMMBA":
        console.log("brand: " + i), a.src = "https://i.ibb.co/BGq95hg/NAMMBA-Header.jpg", s.src = "https://i.ibb.co/pWqW9VM/NAMMBA-Footer.jpg";
        break;
      default:
        a.src = "/img/certificate/FH Pledge_Generic_H.jpg", s.src = "/img/certificate/FH Pledge_Generic_F.jpg"
    }
    document.getElementById("brandHeaderID")
  }()
}]);
//# sourceMappingURL=bundle.js.map